import Configs from '@/constants/configs';

// 导出 showImage 函数
export { showImage } from './show-image';

//防止重复点击

/**
 * 防止重复点击的高阶函数
 * @param fn 需要执行的函数
 * @param delay 防抖延迟时间，默认为1000ms
 * @returns 包装后的函数
 */
export const preventDuplicateClick = <T extends (...args: any[]) => any>(fn: T, delay = 1500): ((...args: Parameters<T>) => Promise<ReturnType<T> | void>) => {
  let isClicking = false;
  let timer: NodeJS.Timeout | null = null;

  return async (...args: Parameters<T>): Promise<ReturnType<T> | void> => {
    if (isClicking) {
      return;
    }

    isClicking = true;

    try {
      const result = await fn(...args);
      return result;
    } finally {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        isClicking = false;
        timer = null;
      }, delay);
    }
  };
};


export const logPrint = (message?: any, ...optionalParams: any[]) => {
  if (!Configs.isProd) {
    console.log(message, ...optionalParams);
  }
};

